import { render, staticRenderFns } from "./project_create.vue?vue&type=template&id=73b7f74c&scoped=true"
import script from "./project_create.vue?vue&type=script&lang=js"
export * from "./project_create.vue?vue&type=script&lang=js"
import style0 from "./project_create.vue?vue&type=style&index=0&id=73b7f74c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b7f74c",
  null
  
)

export default component.exports